import type { StatsSnapshot } from './gameplay-snapshot';
import { unitStats as stats } from './index';

export const updateCollegeStats = (state: StatsSnapshot) => {
  const college = state.generators.college;

  const generatedSeminaries = college.owned * college.baseGeneration;

  stats.college = {
    buildingsGeneration: generatedSeminaries,
  };
};
